//import React, { useEffect } from 'react';
import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import StocksType from './StocksType';

///const filter = createFilterOptions<StocksType>();

export default function Home() {

  const [value, setValue] = React.useState<StocksType | null>(null);
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState<StocksType[]>([]);

  const [data, setData] = React.useState({
    ticker: "",
    company_name: "",
    open: "",
    change_percent: "",
    change: "",
    public_float: "",
    outstanding_shares: "",
    latest_volume: 0
  });

  const debounce = (func: Function, wait: number) => {
    let timeout: ReturnType<typeof setTimeout>;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const searchCache = React.useRef<Record<string, StocksType[]>>({});

  const searchStocks = React.useCallback(
    debounce(async (searchTerm: string) => {
      if (searchTerm.length < 2) {
        setOptions([]);
        return;
      }

      if (searchCache.current[searchTerm]) {
        setOptions(searchCache.current[searchTerm]);
        return;
      }

      try {
        const response = await fetch(`/stocks/search?q=${encodeURIComponent(searchTerm)}`);
        const data = await response.json();
        searchCache.current[searchTerm] = data;
        setOptions(data);
      } catch (error) {
        console.error('Error fetching stocks:', error);
        setOptions([]);
      }
    }, 300),
    []
  );

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (value !== null) {
      const stockInput = e.currentTarget.querySelector('input[name="stock"]') as HTMLInputElement;
      if (stockInput) {
        stockInput.value = value.name;
      }
      e.currentTarget.submit();
    }
  }

  return (
    <div className="row">
      <div className="col-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <form className="forms-sample" action="/search" method="get" onSubmit={handleSubmit}>
              <Autocomplete
                value={value}
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    setValue({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    setValue({
                      name: newValue.inputValue,
                    });
                  } else {
                    setValue(newValue);
                    if (newValue) {
                      const stockInput = document.querySelector('input[name="stock"]') as HTMLInputElement;
                      if (stockInput) {
                        stockInput.value = newValue.name;
                      }
                      const form = document.querySelector('.forms-sample') as HTMLFormElement;
                      form?.submit();
                    }
                  }
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                  searchStocks(newInputValue);
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                className="form-group"
                options={options}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.name;
                }}
                renderOption={(option) => option.name}
                //style={{ width: 300 }}
                fullWidth
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Find stock to analyze"
                    color="primary"
                    variant="outlined"
                    name="stock"
                    // Prevent form submission on enter key
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                  />
                )}
              />
              <div className="form-group">
                <button type="submit" className="btn btn-gradient-primary">Search</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
